import { Component, Input, ElementRef, ViewChildren, Injector } from '@angular/core';
import { Events } from 'ionic-angular';
import { first } from 'rxjs/operator/first';
import { Domanda_super } from './domanda_super';
import { TranslateService } from '@ngx-translate/core';




/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'completamultipla_6',
  templateUrl: 'completamultipla_6.html',
})

export class CompletaMultipla_6Component extends Domanda_super {

  @Input('domanda') domanda: any;
  @Input('mq') mq: any;
  @Input('settingsmq') settingsmq: any;
  @ViewChildren('button') questions: ElementRef;
  output: any;
  iselect_opened = [];
  rispbutton = [];
  risposte_selezionabili = [];
  risposte_conferma = [];
  showconferma: boolean = true;
  showfeed: boolean = false;
  feed = '';
  count_domande = 0;
  showtime: boolean = true;
  constructor(public events: Events, inj: Injector, public translate: TranslateService) {
    super(inj);
    this.output = 'test string';

  }
  position_class(h, len) {
    if (h == 0) {
      return 'first';
    }
    else if (h == len - 1)
      return 'last';
    else
      return '';
  }
  frase_completa = '';
  ngOnInit(): void {

    this.events.publish('start_tempo', this.domanda);
    var risp_aux = [];
    for (let i = 0; i < this.domanda['RispostaMicroStepList'].length; i++) {


      this.iselect_opened[i] = false;
      this.rispbutton[i] = { testo: '' };
      let r = this.domanda['RispostaMicroStepList'][i];
      if (r.punti != '0') {
        // this.frase_completa += r.testo.replace(/(<([^>]+)>)/ig,"")+'&nbsp;';
        this.count_domande++;
      }


      risp_aux.push(r);
    }
    if (this.settingsmq.risposteCausali == '1')
      this.risposte_selezionabili = this.shuffle(risp_aux);
    else
      this.risposte_selezionabili = risp_aux;

    if (this.domanda.durataMinima != '0') {
      this.showtime = false;
    }
    this.events.subscribe('tempo_' + this.domanda.id, (tipotempo) => {
      if (tipotempo == 'minima')
        this.showtime = true;
      else if (tipotempo == 'massima')
        this.conferma('tempo');
    });
  }

  ngAfterViewInit(): void {


  }
  openselect(i) {

    if (!this.showconferma)
      return;
    for (let g = 0; g < this.iselect_opened.length; g++) {
      if (this.iselect_opened[g] == true)
        return;
    }

    /*if (this.rispbutton[i].testo != '')
      this.risposte_selezionabili.unshift(this.rispbutton[i]);
    */

    this.iselect_opened[i] = true;


  }

  sel(r, i) {
    if (!this.showconferma)
      return;


    //this.risposte_selezionabili.splice(this.risposte_selezionabili.indexOf(r), 1);
    for (let f = 0; f < this.rispbutton.length; f++) {
      if (this.rispbutton[f].id == r.id)
        this.rispbutton[f] = { 'testo': '' };
    }

    this.iselect_opened[i] = false;
    this.rispbutton[i] = r;
    let risposte_output = [];

    this.rispbutton.forEach(element => {
      if (element.id != undefined)
        risposte_output.push(element.id);
    });

    this.risposte_conferma = risposte_output;


  }

  changestyle(esatte, errate) {
    var x = document.getElementsByClassName("button_question");
    var i;
    for (i = 0; i < x.length; i++) {
      var l = x[i];

      if (esatte.indexOf(l['id']) != -1) {
        l.classList.add('green');
      }
      else if (errate.indexOf(l['id']) != -1) {
        l.classList.add('red');
      }
    }
  }

  prosegui() {
    this.events.publish('stop_tempo', this.domanda);
    this.events.publish('completamultipla', this.domanda, this.risposte_conferma);
  }
  conferma(tempo?) {
    this.translate.get('domande.ERRRISPOSTE').subscribe(v => {
      if (this.risposte_conferma.length != this.count_domande && tempo != 'tempo') {
        // this.feed = 'Devi inserire tutte le risposte';
        // this.showfeed = true;
        this.presentToast(v);
        return;
      }

      this.events.publish('stop_tempo_parziale', this.domanda);
      let errate = [];
      let esatte = [];
      let corrette = [];
      for (let i = 0; i < this.domanda['RispostaMicroStepList'].length; i++) {
        let r = this.domanda['RispostaMicroStepList'][i];
        if (r.punti != '0')
          corrette.push(r.id);
        if (this.risposte_conferma.indexOf(r.id) != -1 && r.punti == '0')
          errate.push(r.id);
      }
      for (let i = 0; i < corrette.length; i++) {
        let c = corrette[i];
        if (c == this.risposte_conferma[i])
          esatte.push(c);
        else
          errate.push(c);
      }
      //console.log('esatte', esatte);
      //console.log('errate', errate);
      if (!this.settingsmq['istest'])
        this.changestyle(esatte, errate);
      if (errate.length == 0)
        this.feed = this.domanda['feedbackPositivo'];
      else if (esatte.length > 0)
        this.feed = this.domanda['feedbackParziale'];
      else
        this.feed = this.domanda['feedbackNegativo'];

      //tutta la logica
      this.showfeed = true;
      this.showconferma = false;

      if (this.settingsmq['istest'])
        this.prosegui();
    });
  }



  clone(obj) {
    let copy = (JSON.parse(JSON.stringify(obj)));
    return copy;
  }
  shuffle(array) {
    var currentIndex = array.length, temporaryValue, randomIndex;
    while (0 !== currentIndex) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  }
}



// WEBPACK FOOTER //
// ./src/pages/msteps/completamultipla_6.ts